export const shouldDisplayNotAvailableSPUMessage = ({
  isStorePickUpRestricted,
  hasSetFavouriteStore,
  hasSelectedVariant,
  storeInStock,
  stsInStock,
}: {
  isStorePickUpRestricted: boolean;
  hasSetFavouriteStore: boolean;
  hasSelectedVariant: boolean;
  storeInStock: boolean;
  stsInStock: boolean;
}) =>
  isStorePickUpRestricted ||
  (hasSetFavouriteStore && hasSelectedVariant && !storeInStock && !stsInStock);
